import BookDemo from "./BookDemo";

export { Page }

function Page() {
  return <BookDemo />;
}